import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import HighlightedCode from "examples/HighlightedCode";
import DataTable from "examples/Tables/DataTable";
import React from "react";
import sampleResponses from "static-data/sample-responses";
import sampleRequests from "static-data/sample-requests";
import useCopyToClipboard from "../../../../custom-hooks/useCopyToClipboard";
import MDButton from "components/MDButton";
import { ContentCopy } from "@mui/icons-material";
import { useMaterialUIController } from "context";
import PropTypes from "prop-types";
import HttpClientCsharp from "../../journal/code/HTTP_Client_Request_Csharp";
import HttpClientCsharpLight from "../../journal/code/HTTP_Client_Request_CsharpLight";
import HttpClientPython from "../../journal/code/HTTP_Client_Request_Python";
import HttpClientPythonLight from "../../journal/code/HTTP_Client_Request_PythonLight";
import HttpClientPostJournalEntryCsharp from "../../journal/code/HTTP_Client_Request_Post_Journal_Entry_Csharp";
import HttpClientPostJournalEntryCsharpLight from "../../journal/code/HTTP_Client_Request_Post_Journal_Entry_CsharpLight";
import HttpClientPostJournalEntryPython from "../../journal/code/HTTP_Client_Request_Post_Journal_Entry_Python";
import HttpClientPostJournalEntryPythonLight from "../../journal/code/HTTP_Client_Request_Post_Journal_Entry_PythonLight";
import HttpClientPostJournalEntryBatchCsharp from "../../journal/code/HTTP_Client_Request_Post_Journal_Entry_Batch_Csharp";
import HttpClientPostJournalEntryBatchCsharpLight from "../../journal/code/HTTP_Client_Request_Post_Journal_Entry_Batch_CsharpLight";
import HttpClientPostJournalEntryBatchPython from "../../journal/code/HTTP_Client_Request_Post_Journal_Entry_Batch_Python";
import HttpClientPostJournalEntryBatchPythonLight from "../../journal/code/HTTP_Client_Request_Post_Journal_Entry_Batch_PythonLight";

const ApiDescription = ({ data, search }) => {
  // Fetch Color Modes
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [, copy] = useCopyToClipboard();

  const filter = () => {
    return data?.filter((childVal) => {
      if (search?.toLowerCase() === "") {
        return childVal;
      } else {
        return (
          childVal?.parentHeading
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.mainHeading
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.mainHeadingStatic
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.mainHeadingDesc
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.mainHeadingDescTwo
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.mainHeadingDescThree
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.mainHeadingDescFour
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.mainHeadingDescStatic
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.mainHeadingDescStaticTwo
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.endPointDesc?.toLowerCase()?.includes(search.toLowerCase())
        );
      }
    });
  };
  const filtered = filter();
  const themeMode = darkMode ? "dark-tbl" : "light-tbl";

  return (
    <>
      {filtered.length === 0 && (
        <MDTypography
          variant="h3"
          fontWeight="regular"
          fontFamily="inherit"
          textAlign="center"
          lineHeight={2}
          id="no-data-found"
        >
          No Results Found!
        </MDTypography>
      )}
      {filtered.length > 0 &&
        filtered.map((childVal) => {
          return (
            <>
              {childVal.mainGridIdStatic && (
                <Grid
                  container
                  xs={12}
                  mt={4}
                  key={childVal.mainGridIdStatic}
                  id={childVal.mainGridIdStatic}
                >
                  {childVal.mainHeadingStatic && (
                    <MDTypography
                      variant="h4"
                      fontWeight="bold"
                      fontFamily="inherit"
                      lineHeight={3}
                      className="section"
                      width="100%"
                      display="block"
                    >
                      {childVal.mainHeadingStatic}
                    </MDTypography>
                  )}
                  {childVal.mainHeadingDescStatic && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      {childVal.mainHeadingDescStatic}
                    </MDTypography>
                  )}
                  {childVal?.email && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                      display="block"
                      width="100%"
                    >
                      {childVal?.email?.map((item) => {
                        return (
                          <>
                            <a href={"mailto:" + item}>{item}</a>
                            <br />
                          </>
                        );
                      })}
                    </MDTypography>
                  )}
                  {childVal.mainHeadingDescStaticTwo && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      {childVal.mainHeadingDescStaticTwo}
                    </MDTypography>
                  )}
                </Grid>
              )}
              {childVal.parentHeading && (
                <MDTypography
                  variant="h4"
                  fontWeight="bold"
                  fontFamily="inherit"
                  lineHeight={2}
                  id={childVal.parentId ? childVal.parentId : ""}
                  className="section"
                >
                  {childVal.parentHeading}
                </MDTypography>
              )}
              {childVal.mainHeading && (
                <Grid
                  container
                  xs={12}
                  mt={4}
                  key={childVal.mainGridId}
                  id={childVal.mainGridId}
                >
                  <Grid
                    item
                    xs={12}
                    md={8}
                    pr={2}
                    id={childVal.mainGridId}
                    className={
                      childVal.mainHeading ===
                      "Get Access to External API Fund Request"
                        ? "no-sticky section"
                        : "section"
                    }
                  >
                    {childVal.mainHeading && (
                      <MDTypography
                        variant={childVal?.parentId ? "h5" : "h4"}
                        fontWeight="bold"
                        fontFamily="inherit"
                        lineHeight={2}
                        id={
                          childVal.accessTokenId ? childVal.accessTokenId : ""
                        }
                        className="section"
                      >
                        {childVal.mainHeading}
                      </MDTypography>
                    )}
                    {childVal.mainHeadingDesc && (
                      <p>
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          {childVal.mainHeadingDesc}
                        </MDTypography>
                      </p>
                    )}
                    {childVal.mainHeadingDescTwo && (
                      <MDTypography
                        variant="p"
                        fontSize="14px"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                      >
                        {childVal.mainHeadingDescTwo}
                      </MDTypography>
                    )}
                    {childVal?.email && (
                      <MDTypography
                        variant="p"
                        fontSize="14px"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                        display="block"
                        width="100%"
                        color="#0d6efd!important"
                      >
                        {childVal?.email?.map((item, index) => {
                          return (
                            <>
                              <a href={"mailto:" + item}>{item}</a>
                              <br />
                            </>
                          );
                        })}
                      </MDTypography>
                    )}
                    {childVal.mainHeadingDescThree && (
                      <p>
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          {!childVal?.email && <b>NOTE: </b>}
                          {childVal.mainHeadingDescThree}
                        </MDTypography>
                      </p>
                    )}
                    {childVal.mainHeadingDescFour && (
                      <p>
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          <b>Api Availability Notice: </b>
                          {childVal.mainHeadingDescFour}
                        </MDTypography>
                      </p>
                    )}
                    {childVal.endpointId && (
                      <MDTypography
                        variant="h5"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                        id={childVal.endpointId ? childVal.endpointId : ""}
                        className="section"
                      >
                        {childVal.endPointHeading}
                      </MDTypography>
                    )}
                    {childVal.endPointMethod && (
                      <MDTypography
                        variant="h6"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={1}
                        className={
                          childVal.endPointMethod === "GET"
                            ? "post-badge get"
                            : "post-badge"
                        }
                      >
                        {childVal.endPointMethod}
                      </MDTypography>
                    )}
                    {childVal.endPointDesc && (
                      <>
                        <MDTypography
                          variant="h6"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={1}
                          className="link-badge"
                        >
                          {childVal.endPointDesc}
                          <MDButton
                            variant="text"
                            className="copyiconparent"
                            onClick={() => copy(childVal.endPointDesc)}
                          >
                            <ContentCopy className="copyicon" />
                          </MDButton>
                        </MDTypography>
                        <br />
                      </>
                    )}
                    {childVal.endPointNote && (
                      <>
                        <p>
                          <MDTypography
                            variant="p"
                            fontSize="14px"
                            fontWeight="regular"
                            fontFamily="inherit"
                            lineHeight={2}
                          >
                            {childVal.endPointNote}
                          </MDTypography>
                        </p>
                        <br />
                      </>
                    )}
                    {childVal.endPointDesc2 && (
                      <MDTypography
                        variant="h6"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={1}
                        className={
                          childVal.endPointMethod === "GET"
                            ? "post-badge get"
                            : "post-badge"
                        }
                      >
                        {childVal.endPointMethod}
                      </MDTypography>
                    )}
                    {childVal.endPointDesc2 && (
                      <>
                        <MDTypography
                          variant="h6"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={1}
                          className="link-badge"
                        >
                          {childVal.endPointDesc2}
                          <MDButton
                            variant="text"
                            className="copyiconparent"
                            onClick={() => copy(childVal.endPointDesc2)}
                          >
                            <ContentCopy className="copyicon" />
                          </MDButton>
                        </MDTypography>
                        <br />
                      </>
                    )}
                    {childVal.requestHeader && (
                      <>
                        <MDTypography
                          variant="h5"
                          fontWeight="regular"
                          fontFamily="inherit"
                          mt={3}
                          lineHeight={2}
                          id={childVal.requestHeaderId}
                          className="section"
                        >
                          {childVal.requestHeader}
                        </MDTypography>
                        <MDBox mt={3} className="table-doc">
                          <Card>
                            <MDBox className={themeMode}>
                              <DataTable
                                table={{
                                  columns: childVal.requestHeaderTable.columns,
                                  rows: childVal.requestHeaderTable.rows,
                                }}
                                isSorted={false}
                                entriesPerPage={false}
                                showTotalEntries={false}
                                noEndBorder
                              />
                            </MDBox>
                          </Card>
                        </MDBox>
                        {childVal.requestHeaderNote && (
                          <p>
                            <MDTypography
                              variant="p"
                              fontSize="14px"
                              fontWeight="regular"
                              fontFamily="inherit"
                              lineHeight={2}
                            >
                              <b>NOTE: </b>
                              {childVal.requestHeaderNote}
                            </MDTypography>
                          </p>
                        )}

                        {childVal.requestHeaderNoteTwo && (
                          <p>
                            <MDTypography
                              variant="p"
                              fontSize="14px"
                              fontWeight="regular"
                              fontFamily="inherit"
                              lineHeight={2}
                            >
                              {childVal.requestHeaderNoteTwo}
                            </MDTypography>
                          </p>
                        )}
                      </>
                    )}
                    {childVal.extraLine && (
                      <p>
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          {childVal.extraLine}
                        </MDTypography>
                      </p>
                    )}
                    {childVal.requestBody && (
                      <MDTypography
                        variant="h5"
                        fontWeight="regular"
                        fontFamily="inherit"
                        mt={3}
                        lineHeight={2}
                        id={
                          childVal.requestBodyId ? childVal.requestBodyId : ""
                        }
                        className="section"
                      >
                        {childVal.requestBody}
                      </MDTypography>
                    )}
                    {childVal.requestBodyDesc && (
                      <p>
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          {childVal.requestBodyDesc}
                        </MDTypography>
                      </p>
                    )}
                    {childVal.statusCodeCreated && (
                      <p className="staus-code created">
                        {childVal.statusCodeCreated}
                      </p>
                    )}
                    {childVal.requestBodyTable && (
                      <MDBox mt={3} className="table-doc">
                        <MDTypography
                          variant="h5"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                          mt={2}
                          className="section"
                        >
                          Request Body
                        </MDTypography>
                        <Card>
                          <MDBox className={themeMode}>
                            <DataTable
                              table={{
                                columns: childVal.requestBodyTable.columns,
                                rows: childVal.requestBodyTable.rows,
                              }}
                              isSorted={false}
                              entriesPerPage={false}
                              showTotalEntries={false}
                              noEndBorder
                            />
                          </MDBox>
                        </Card>
                      </MDBox>
                    )}
                    {childVal.requestBodyTableTwo && (
                      <MDBox mt={3} className="table-doc">
                        <Card>
                          <MDBox className={themeMode}>
                            <DataTable
                              table={{
                                columns: childVal.requestBodyTableTwo.columns,
                                rows: childVal.requestBodyTableTwo.rows,
                              }}
                              isSorted={false}
                              entriesPerPage={false}
                              showTotalEntries={false}
                              noEndBorder
                            />
                          </MDBox>
                        </Card>
                      </MDBox>
                    )}
                    {childVal.requestBodyImage && (
                      <img
                        src={childVal.requestBodyImage}
                        className="center-img section"
                        id={childVal.requestBodyImageId}
                        alt="Response Header"
                      />
                    )}

                    {childVal?.SampleCode && (
                      <MDBox mt={3}>
                        <MDTypography
                          variant="h5"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                          id={childVal.SampleCodeId}
                        >
                          {childVal.SampleCodeTitle}
                        </MDTypography>
                        {/* Conditional rendering based on endpoint type */}
                        {(!childVal.sampleCodeType ||
                          childVal.sampleCodeType === "auth") && (
                          <>
                            {darkMode ? (
                              <HttpClientCsharp />
                            ) : (
                              <HttpClientCsharpLight />
                            )}

                            <MDTypography
                              variant="h5"
                              fontWeight="regular"
                              fontFamily="inherit"
                              lineHeight={2}
                              mt={3}
                            >
                              HTTP Client Request Python :
                            </MDTypography>
                            {darkMode ? (
                              <HttpClientPython />
                            ) : (
                              <HttpClientPythonLight />
                            )}
                          </>
                        )}

                        {childVal.sampleCodeType === "postJournalEntry" && (
                          <>
                            {darkMode ? (
                              <HttpClientPostJournalEntryCsharp />
                            ) : (
                              <HttpClientPostJournalEntryCsharpLight />
                            )}

                            <MDTypography
                              variant="h5"
                              fontWeight="regular"
                              fontFamily="inherit"
                              lineHeight={2}
                              mt={3}
                            >
                              HTTP Client Request Python :
                            </MDTypography>
                            {darkMode ? (
                              <HttpClientPostJournalEntryPython />
                            ) : (
                              <HttpClientPostJournalEntryPythonLight />
                            )}
                          </>
                        )}

                        {childVal.sampleCodeType ===
                          "postJournalEntryBatch" && (
                          <>
                            {darkMode ? (
                              <HttpClientPostJournalEntryBatchCsharp />
                            ) : (
                              <HttpClientPostJournalEntryBatchCsharpLight />
                            )}

                            <MDTypography
                              variant="h5"
                              fontWeight="regular"
                              fontFamily="inherit"
                              lineHeight={2}
                              mt={3}
                            >
                              HTTP Client Request Python :
                            </MDTypography>
                            {darkMode ? (
                              <HttpClientPostJournalEntryBatchPython />
                            ) : (
                              <HttpClientPostJournalEntryBatchPythonLight />
                            )}
                          </>
                        )}

                        {childVal.sampleCodeNote && (
                          <p style={{ marginTop: "15px" }}>
                            <MDTypography
                              variant="p"
                              fontSize="14px"
                              fontWeight="regular"
                              fontFamily="inherit"
                              lineHeight={2}
                            >
                              <b>Note: </b>
                              {childVal.sampleCodeNote}
                            </MDTypography>
                          </p>
                        )}
                      </MDBox>
                    )}
                  </Grid>

                  {/* {childVal.reqObjKey && (
                    <Grid item xs={12} md={4}>
                      <MDTypography variant="h6" fontWeight="regular">
                        Request Object
                      </MDTypography>
                      <HighlightedCode
                        code={sampleRequests.journal[childVal.reqObjKey].trim()}
                      />
                    </Grid>
                  )} */}

                  {childVal.respBody && (
                    <Grid item xs={12} md={8} pr={2}>
                      <MDTypography
                        variant="h5"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                        id={childVal.respBodyId}
                        className="section"
                      >
                        {childVal.respBody}
                      </MDTypography>
                      {childVal.respBodyStatusCodeSuccess && (
                        <p className="staus-code code-success">
                          {childVal.respBodyStatusCodeSuccess}
                        </p>
                      )}
                      {childVal.respBodyImg && (
                        <img
                          src={childVal.respBodyImg}
                          className="center-img"
                          alt={childVal.respBodyImg}
                        />
                      )}
                      {childVal.respBodyImg2 && (
                        <img
                          src={childVal.respBodyImg2}
                          className="center-img"
                          alt={childVal.respBodyImg2}
                        />
                      )}
                      {childVal.respBodyDesc && (
                        <p>
                          <MDTypography
                            variant="p"
                            fontSize="14px"
                            fontWeight="regular"
                            fontFamily="inherit"
                            lineHeight={2}
                          >
                            {childVal.respBodyDesc}
                          </MDTypography>
                        </p>
                      )}
                      {childVal.respBodySuccess && (
                        <p>
                          <MDTypography
                            variant="p"
                            fontSize="14px"
                            fontWeight="regular"
                            fontFamily="inherit"
                            lineHeight={2}
                            id={childVal.respBodySuccessId}
                            className="section"
                          >
                            <b>Success: </b>
                            {childVal.respBodySuccess}
                          </MDTypography>
                        </p>
                      )}
                      {/* {childVal.successApiResponseObj && (
                        <HighlightedCode
                          code={sampleResponses.journal[
                            childVal.successApiResponseObj
                          ].trim()}
                          enableNumbering={true}
                        />
                      )} */}
                      {childVal.respBodySuccessTableTwo && (
                        <MDBox mt={3} className="table-doc">
                          <Card>
                            <MDBox className={themeMode}>
                              <DataTable
                                table={{
                                  columns:
                                    childVal.respBodySuccessTableTwo.columns,
                                  rows: childVal.respBodySuccessTableTwo.rows,
                                }}
                                isSorted={false}
                                entriesPerPage={false}
                                showTotalEntries={false}
                                noEndBorder
                              />
                            </MDBox>
                          </Card>
                        </MDBox>
                      )}
                      {childVal.respBodySuccessTable && (
                        <MDBox mt={3} className="table-doc">
                          <Card>
                            <MDBox className={themeMode}>
                              <DataTable
                                table={{
                                  columns:
                                    childVal.respBodySuccessTable.columns,
                                  rows: childVal.respBodySuccessTable.rows,
                                }}
                                isSorted={false}
                                entriesPerPage={false}
                                showTotalEntries={false}
                                noEndBorder
                              />
                            </MDBox>
                          </Card>
                        </MDBox>
                      )}
                    </Grid>
                  )}
                  {console.log("Test: ", childVal.respObjKey)}
                  {childVal.respObjKey && (
                    <Grid item xs={12} md={4}>
                      <MDTypography variant="h6" fontWeight="regular">
                        Response Object
                      </MDTypography>
                      <HighlightedCode
                        code={sampleResponses.journal[
                          childVal.respObjKey
                        ].trim()}
                      />
                    </Grid>
                  )}

                  {childVal.respBodyValidationTableTwo && (
                    <Grid item xs={12} md={8} pr={2}>
                      <p className="mt-5">
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                          id={childVal.respBodyValidationId}
                          className="section"
                        >
                          <b>Validation: </b>
                          {childVal.respBodyValidation}
                        </MDTypography>{" "}
                      </p>
                      <MDBox mt={3} className="table-doc">
                        <Card>
                          <MDBox className={themeMode}>
                            <DataTable
                              table={{
                                columns:
                                  childVal.respBodyValidationTableTwo.columns,
                                rows: childVal.respBodyValidationTableTwo.rows,
                              }}
                              isSorted={false}
                              entriesPerPage={false}
                              showTotalEntries={false}
                              noEndBorder
                            />
                          </MDBox>
                        </Card>
                      </MDBox>
                    </Grid>
                  )}
                  {childVal.respBodyValidationTable && (
                    <Grid item xs={12} md={8} pr={2}>
                      <p className="mt-5">
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                          id={childVal.respBodyValidationId}
                          className="section"
                        >
                          <b>Validation: </b>
                          {childVal.respBodyValidation}
                        </MDTypography>{" "}
                      </p>
                      <MDBox mt={3} className="table-doc">
                        <Card>
                          <MDBox className={themeMode}>
                            <DataTable
                              table={{
                                columns:
                                  childVal.respBodyValidationTable.columns,
                                rows: childVal.respBodyValidationTable.rows,
                              }}
                              isSorted={false}
                              entriesPerPage={false}
                              showTotalEntries={false}
                              noEndBorder
                            />
                          </MDBox>
                        </Card>
                      </MDBox>
                    </Grid>
                  )}
                  {/* {childVal.respValidationObjKey && (
                    <Grid item xs={12} md={4}>
                      <MDTypography variant="h6" fontWeight="regular">
                        Validation
                      </MDTypography>
                      <HighlightedCode
                        code={sampleResponses.journal[
                          childVal.respValidationObjKey
                        ].trim()}
                      />
                    </Grid>
                  )} */}
                </Grid>
              )}
            </>
          );
        })}
    </>
  );
};
ApiDescription.propTypes = {
  data: PropTypes.array.isRequired,
  search: PropTypes.string.isRequired,
};
export default ApiDescription;
